import { ModalContext, ModalContextType } from '@/shared/contexts/Modal';
import { isNull } from 'lodash';
import { useContext } from 'react';

type Props = {};

const useModalContext = () : ModalContextType => {
    const modalContext = useContext(ModalContext);

    if (isNull(modalContext)) {
        throw new Error('Modal context is not set.');
    }

    return modalContext;
};

export default useModalContext;
